<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<div class="_idGenObjectLayout-1">
<div class="Altlogo" id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/portalist_theportalist-color.png"/>
</div>
</div>
<h1 class="AdTitle">The Galaxy’s Greatest Newsletter<br/>Delivered to Your Inbox</h1>
<h2 class="AdSubhead" style="margin-top:20px;">Get awesome tales of fantasy and science fiction once a week. </h2>
<div class="_idGenObjectLayout-2">
<div class="button" id="_idContainer001">
<p class="button"><a href="https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&amp;utm_campaign=9781504040259" target="_blank"><span class="White-link-Text">Sign Up Now</span></a></p>
</div>
</div>
<h5 class="Adurl">Visit us at <a href="https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&amp;utm_campaign=9781504040259" target="_blank"><span class="Hyperlink">www.theportalist.com</span></a></h5>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// portalistad.vue?f117810a